import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function useTrackPageView(siteUserId: string | null, pagePath: string) {
  useEffect(() => {
    if (!siteUserId) return;

    supabase.from('page_views').insert({
      site_user_id: siteUserId,
      page_path: pagePath,
      referrer: document.referrer || null,
      user_agent: navigator.userAgent || null,
    });
  }, [siteUserId, pagePath]);
}

export async function trackContactClick(siteUserId: string, contactType: string) {
  await supabase.from('contact_clicks').insert({
    site_user_id: siteUserId,
    contact_type: contactType,
  });
}
